module.exports = __webpack_public_path__ + "img/character@2x.62cb369.jpg";